import ModalMonitoringEvent from './ModalMonitoringEventContainer';

export { ModalMonitoringEvent };


// WEBPACK FOOTER //
// ./src/modules/modal/ModalMonitoringEvent/index.js